import { DropdownMenu as DropdownMenuPrimitive } from "radix-ui";

export const DropdownMenuSubRoot = DropdownMenuPrimitive.Sub;
